import { useAuth0 } from "@auth0/auth0-react";
import LoginButton from "./LoginButton";
import LogoutButton from "./LogoutButton";
import TosCheck from "../Tos/TosCheck";

export default function LoginNavLink() {
  const { isAuthenticated } = useAuth0();
  return (
    <div className="nav-link">
      {isAuthenticated ? <LogoutButton /> : <LoginButton />}
      <TosCheck />
    </div>
  );
}
